module.exports = __webpack_public_path__ + "../resources/img/ic_re_clear_night_solid.c98db326.svg";